module.exports = __webpack_public_path__ + "img/arrow-collapse-right.302af406.svg";